// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__egSa7","theme-light":"styles_theme-light__Dc5Bq","theme-dark":"styles_theme-dark__qNIK3"};